import { Button } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { IoDownloadOutline, IoEyeOutline } from 'react-icons/io5';
import { Tabs, TabsList, TabsTrigger } from '@/shared/ui/Tabs';
import type { ReportDetailTab } from '../types/reportDetail';
import styles from './ReportDetailSubHeader.module.css';

interface ReportDetailSubHeaderProps {
  activeTab: ReportDetailTab;
  onTabChange: (tab: ReportDetailTab) => void;
  isSigned: boolean;
  onDownloadPdf: () => void;
  onAddAddendum: () => void;
  isAddingAddendum?: boolean;
  onOpenReader: () => void;
}

export default function ReportDetailSubHeader({
  activeTab,
  onTabChange,
  isSigned,
  onDownloadPdf,
  onAddAddendum,
  isAddingAddendum = false,
  onOpenReader,
}: ReportDetailSubHeaderProps) {
  return (
    <div className={styles.container}>
      <Tabs
        value={activeTab}
        onValueChange={(v) => onTabChange(v as ReportDetailTab)}
      >
        <TabsList>
          <TabsTrigger value="preview">PDF Preview</TabsTrigger>
          <TabsTrigger value="history">Report</TabsTrigger>
          <TabsTrigger value="attachments">Attachments</TabsTrigger>
        </TabsList>
      </Tabs>

      <div className={styles.actions}>
        <Button size="small" icon={<IoEyeOutline />} onClick={onOpenReader}>
          Open in Reader
        </Button>

        <Button
          size="small"
          icon={<IoDownloadOutline />}
          onClick={onDownloadPdf}
        >
          Download PDF
        </Button>

        {isSigned && (
          <Button
            size="small"
            type="primary"
            onClick={onAddAddendum}
            loading={isAddingAddendum}
          >
            Add Addendum
          </Button>
        )}

        <Button size="small" icon={<EllipsisOutlined />} />
      </div>
    </div>
  );
}
